import * as React from "react";
const SvgSubtractLine = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 11V13H19V11H5Z" }));
export default SvgSubtractLine;
